export default __webpack_public_path__ + "static/with-phone-9569242966d4cdb9582535945a0392a5.png";